<template>
  <div class="bottom">
    <div class="btn-group">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomBtnGroup"
};
</script>

<style lang="scss" scoped>
.bottom {
  background-color: #fff;
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  //屏幕安全区域适配
  .btn-group {
    display: flex;
    width: 100%;
    height: 50px;
    padding: 0 16px;
    background: #fff;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 -2px 4px 0 rgba(243, 245, 249, 0.8);
  }
}
</style>
